import { connect } from "react-redux";
import {
  getBusinessDetails,
  saveBusinessDetails,
  updateBusinessForm,
} from "../../actions/BusinessActions";
import { FiAlertCircle } from "react-icons/fi";
import { useState } from "react";
import { Spinner } from "react-bootstrap";

export const TaxNumberForm = (props) => {
  const [error, setError] = useState("");

  const validateKETaxNumber = (tax_number) => {
    if (!/^[A-Za-z]/.test(tax_number)) {
      setError("Business Tax Number must start with a letter");
      return false;
    }
    if (!/[A-Za-z]$/.test(tax_number)) {
      setError("Business Tax Number must end with a letter");
      return false;
    }
    if (tax_number.length < 11) {
      setError("Business Tax Number must be 11 digits");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    const { tax_number } = props.businessDetailsForm;
    if (!tax_number || tax_number.toString().trim() === "") {
      setError("Business Tax Number cannot be empty");
      return;
    }

    const isValid = validateKETaxNumber(tax_number);

    if (!isValid) {
      return;
    }

    const data = {
      tax_number,
    };
    props.saveBusinessDetails(data, () => {
      props.getBusinessDetails(() => {
        props.onFinish();
      });
    });
  };

  return (
    <div className="label-create col-12">
      {props.businessDetailsForm.errors && (
        <div className={"error-block"}>
          <FiAlertCircle />
          <p>{props.businessDetailsForm.errors}</p>
        </div>
      )}
      <label
        className={`col-12 p-0 d-flex flex-column flex-start text-left ${error ? "error" : ""}`}
      >
        Business Tax Number
        <input
          placeholder={"Enter your business tax identification number"}
          value={props.businessDetailsForm.tax_number}
          onChange={(e) => {
            setError("");
            props.updateBusinessForm({ tax_number: e.target.value });
          }}
          className={error ? "border-danger" : ""}
        />
        <p className={"error text-danger"}>{error}</p>
      </label>
      <button onClick={handleSubmit}>
        {props.businessDetailsForm.loading ? (
          <Spinner animation={"border"} role={"status"} />
        ) : (
          "Save Tax Number"
        )}
      </button>
    </div>
  );
};

const mapStateToProps = ({
  userDetails,
  businessDetails,
  businessDetailsForm,
}) => ({
  userDetails,
  businessDetails: businessDetails.details,
  businessDetailsForm: businessDetailsForm,
});

export default connect(mapStateToProps, {
  updateBusinessForm,
  saveBusinessDetails,
  getBusinessDetails,
})(TaxNumberForm);
